"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../../shared/components/table_actions/TableActionDelete");
var TableActionEdit_1 = require("../../../../../../../shared/components/table_actions/TableActionEdit");
var WrapTableActions_1 = require("../../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var TableActionConfig_1 = require("../../../../../../../shared/components/table_actions/TableActionConfig");
var TableActionCopy_1 = require("../../../../../../../shared/components/table_actions/TableActionCopy");
var BonusTPLLocalesList = /** @class */ (function (_super) {
    __extends(BonusTPLLocalesList, _super);
    function BonusTPLLocalesList(props) {
        var _this = _super.call(this, props) || this;
        _this.columns = [
            {
                title: 'Название',
                dataIndex: _this.props.data.dk_wager_title,
                key: _this.props.data.dk_wager_title,
                width: 200,
            }, {
                title: 'Шаблон бонуса',
                dataIndex: _this.props.data.dk_app_language_id,
                key: _this.props.data.dk_app_language_id,
                width: 200,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, _this.props.rootRecord.title));
                }
            }, {
                title: 'Язык',
                dataIndex: _this.props.data.dk_app_language_title,
                key: _this.props.data.dk_app_language_title,
                width: 200,
            }, {
                title: 'Валюта',
                dataIndex: _this.props.data.dk_app_currency_title,
                key: _this.props.data.dk_app_currency_title,
                width: 200,
            }, {
                title: 'Добавлен',
                dataIndex: _this.props.data.dk_date_added,
                key: _this.props.data.dk_date_added,
                align: "center",
                width: 200,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added.format(_this.props.state.getDateTimeFormat())));
                }
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditClick(record); } }),
                    React.createElement(TableActionConfig_1.default, { hint: "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C", onClick: function () { _this.onConfigClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }),
                    React.createElement(TableActionCopy_1.default, { hint: "Клонировать", confirmText: "\u041A\u043B\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onCloneData(record); } }))); },
                width: 100
            }
        ];
        return _this;
    }
    BonusTPLLocalesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
        }, function () {
            _this.props.data.LoadData(_this.props.rootRecord.key);
        });
        this.props.state.setExtBreadCrumbPath(["\u0428\u0430\u0431\u043B\u043E\u043D\u044B \u043B\u043E\u043A\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0439 \u0431\u043E\u043D\u0443\u0441\u0430 - [" + this.props.rootRecord.title + "]"]);
    };
    BonusTPLLocalesList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    BonusTPLLocalesList.prototype.onCloneData = function (record) {
        var _this = this;
        this.props.DlgCloneBonusLocale.SetDialogTitle("Клонировать локализацию")
            .SetOnNoClick(function () { _this.props.DlgCloneBonusLocale.Close(); })
            .SetCurrenciesAvail(this.props.availCurrencies)
            .SetLanguagesAvail(this.props.availLanguages)
            .SetOnYesClick(function (currencyId, languageId) {
            _this.props.data.doCloneData(record.key, languageId, currencyId, function () {
                _this.props.DlgCloneBonusLocale.Close();
                _this.props.data.LoadData(_this.props.rootRecord.key, function () {
                    notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u041B\u043E\u043A\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F \u0431\u043E\u043D\u0443\u0441\u0430 \u043A\u043B\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0430 !"));
                });
            });
        }).Show();
    };
    BonusTPLLocalesList.prototype.onEditClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    BonusTPLLocalesList.prototype.onConfigClick = function (record) {
        if (this.props.onConfigClick) {
            this.props.onConfigClick(record);
        }
    };
    BonusTPLLocalesList.prototype.onDeleteClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u0417\u0430\u043F\u0438\u0441\u044C \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u0430"));
        });
    };
    BonusTPLLocalesList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData(this.props.rootRecord.key);
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
        if (action === "back") {
            if (this.props.onGoBack) {
                this.props.onGoBack();
            }
        }
    };
    BonusTPLLocalesList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить", back: "Назад" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.data, pagination: {
                    defaultPageSize: this.props.state.UITablePageSize,
                    showSizeChanger: true,
                    position: "bottom",
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", { style: { margin: 0, display: "flex", flexDirection: "row", flexWrap: "nowrap" } },
                        React.createElement("div", { style: {
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "flex-start",
                                flexWrap: "nowrap"
                            } },
                            React.createElement("div", null,
                                React.createElement("div", null,
                                    React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D"),
                                    " : [",
                                    record.date_added.format(_this.props.state.getDateTimeFormat()),
                                    "]"),
                                React.createElement("div", null,
                                    React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D"),
                                    " : [",
                                    record.date_changed.format(_this.props.state.getDateTimeFormat()),
                                    "]"),
                                React.createElement("div", null,
                                    React.createElement("b", null, "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435(\u0432\u0435\u0439\u0434\u0436\u0435\u0440):"),
                                    " [",
                                    record.wager_description_tpl,
                                    "]"),
                                React.createElement("div", null,
                                    React.createElement("b", null, "\u041E\u0442\u044B\u0433\u0440\u044B\u0448(\u0432\u0435\u0439\u0434\u0436\u0435\u0440):"),
                                    " [",
                                    record.wager_condition_tpl,
                                    "]"),
                                React.createElement("div", null,
                                    React.createElement("b", null, "\u0422\u0438\u0437\u0435\u0440(\u0432\u0435\u0439\u0434\u0436\u0435\u0440):"),
                                    " [",
                                    record.wager_pre_create_teaser_tpl,
                                    "]")),
                            React.createElement("div", null,
                                React.createElement("img", { style: { marginLeft: "20px" }, height: 110, src: "" + _this.props.data.DATA.cdn_baseurl + record.wager_pre_create_teaser_img_url })))));
                } })));
    };
    return BonusTPLLocalesList;
}(React.Component));
exports.default = BonusTPLLocalesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_bonus_templates/ui/component/locales/LocaleTPLList.tsx
// module id = 1905
// module chunks = 0